import { UserCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  user_category_ids: {
    'ui:widget': UserCategorySelectionWidget,
  },
});

export default uiSchema;
